import {appHref} from '../../../../helper/app-href';
import {BusinessOrderStartErrorFetch} from './business-order-start-error-fetches.model';

interface Props {
  errorFetches?: BusinessOrderStartErrorFetch[];
}

export function BusinessOrderStartErrorFetchLinks({errorFetches}: Props) {
  if (!errorFetches?.length) {
    return null;
  }

  return <div className="pt-4">
    Betroffene Abrufe:
    <ol>
      {errorFetches.map(fetchError =>
        <li key={fetchError.id}>
          <a className="ml-1 font-bold"
             href={appHref(`/workflow/${fetchError.workflow_id}#fetch-${fetchError.id}`)}
             title="Abruf im Vorgang öffnen"
             target="_blank">
            Abruf {fetchError.ordering} (#{fetchError.id})
          </a>
        </li>,
      )}
    </ol>
  </div>;
}
